import { StatusWrappedData } from '../types';

export function statusWrappedDataHelper<T>(
  { data, loading, errored, errorMessage }: StatusWrappedData<T>,
  previousData?: StatusWrappedData<T> | null | undefined
): StatusWrappedData<T> {
  return loading === false
    ? {
        ...previousData,
        loading,
      }
    : {
        data: data && !errored && !loading ? data : null,
        errored: !!errored,
        errorMessage,
        loading,
      };
}
